var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiryAlertActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#F94343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.086H12L6.324 17.998l.001.002h11.35v-.002L12.002 7.086zM11.438 10h1.125v4.5h-1.125V10zM12 17a.75.75 0 1 1 0-1.498A.75.75 0 0 1 12 17z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-13a.5.5 0 0 1-.444-.73l6.5-12.5a.5.5 0 0 1 .888 0l6.5 12.5a.5.5 0 0 1-.444.73zM6.325 18h11.35v-.002L12.002 7.086h-.002L6.324 17.998l.001.002z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiryAlertActiveIcon);
export default __webpack_public_path__ + "static/media/expiryAlertActiveIcon.46b1452566c8b4bc038f299e3870cd07.svg";
export { ForwardRef as ReactComponent };